export const searchActions = {
    START: 0,
    NEXT: 1,
    TYPECHANGE: 3,
    TEXTCHANGE: 4,
    STARTCHANGE: 5,
    IGNORECASECHANGE: 6
};
